module.exports = __webpack_public_path__ + "static/img/icon2.8ef4af2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/all/icon2.png
// module id = L9qU
// module chunks = 0